import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'; // Assuming we will create this CSS file

const Header: React.FC = () => {
  return (
    <header className="main-header">
      <div className="container">
        {/* Responsive Banner Section */}
        <section className="banner-hero">
            <h1>Sabots du Petit Morin</h1>
            <p>Balades à cheval et randonnées personnalisées : l'aventure au rythme des chevaux.</p>
        </section>

        <div className="banniere-container">
          <img src="/banniere.jpeg" alt="Bannière Sabots du Petit Morin" />
        </div>

        <nav>
          <ul className="main-nav-list">
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/chevaux">Nos Chevaux</Link></li>
            <li><Link to="/prestations">Prestations</Link></li>
            <li><Link to="/calendrier">Calendrier</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;